import dataTagPoll from './src/data-tag-pool.vue'

export default dataTagPoll
